import React from 'react'

export default class IconsDnDRadioButtons extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <g clipPath='url(#clip0_4158_4882)'>
                    <path
                        d='M8.00001 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325C4.31811 1.33325 1.33334 4.31802 1.33334 7.99992C1.33334 11.6818 4.31811 14.6666 8.00001 14.6666Z'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.99994 10.1334C9.17815 10.1334 10.1333 9.17824 10.1333 8.00003C10.1333 6.82182 9.17815 5.8667 7.99994 5.8667C6.82173 5.8667 5.86661 6.82182 5.86661 8.00003C5.86661 9.17824 6.82173 10.1334 7.99994 10.1334Z'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_4158_4882'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
